<template>
  <div class="charge-success">
    <div ref="imageWrapper">
      <div class="success">
        <div class="img">
          <img class="img-icon" src="../assets/success.png"/>
          <p style="font-weight: 600; font-size: 18px">支付成功</p>
        </div>
      </div>
      <div class="success-detail">
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="col-left-suc">收款商家</el-col>
          <el-col :span="16" class="col-right">{{merchant}}</el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="col-left-suc">费用名称</el-col>
          <el-col :span="16" class="col-right">{{contName}}</el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="col-left-suc">缴费金额</el-col>
          <el-col :span="16" class="col-right">{{chargePrice}}元</el-col>
        </el-row>
      </div>
      <div class="success-detail">
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="col-left-suc">流水号</el-col>
          <el-col :span="16" class="col-right">{{waterNum}}</el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="col-left-suc">发票领取</el-col>
          <el-col :span="16" class="col-right">{{billAddress}}</el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="col-left-suc">服务电话</el-col>
          <el-col :span="16" class="col-right">{{billTel}}</el-col>
        </el-row>
      </div>
    </div>
    <div class="button">
      <el-button style="width: 70%;" type="success" size="small" @click="toImage">生成截图</el-button>
    </div>
    <el-dialog title="长按保存图片哦" :visible.sync="dialogTableVisible">
      <img :src="imgUrl" style="width: 260px; height: 300px;"/>
    </el-dialog>
  </div>
</template>

<script>
  import html2canvas from "html2canvas"

  const wx = window.jWeixin || require('weixin-js-sdk')
  export default {
    name: "chargeSuccess",
    data() {
      return {
        merchant: "盘锦盛宏热力有限公司",
        contName: "取暖费",
        chargePrice: this.$route.query.totalFee,
        waterNum: this.$route.query.bankBusinessNo,
        billAddress: this.$route.query.billAddress,
        billTel: this.$route.query.billTel,
        imgUrl: "",
        dialogTableVisible: false,
      }
    },
    methods: {
      toImage() {
        html2canvas(this.$refs.imageWrapper).then(canvas => {
          let dataURL = canvas.toDataURL("image/png");
          this.imgUrl = dataURL;
          if (this.imgUrl !== "") {
            this.dialogTableVisible = true;
          }
        });
      }
    }
  }
</script>

<style scoped>
  .img-icon {
    width: 70px;
    height: 70px;
  }

  .img {
    text-align: center;
    margin-top: 10vh;
  }

  .success {
    width: 100%;
    height: 20vh;
    border-bottom: 1px solid #F2F6FC;
  }

  .success-detail {
    border-bottom: 1px solid #F2F6FC;
    padding-bottom: 15px;
  }

  .col-left-suc {
    margin-top: 5px;
    font-size: 13px;
    font-weight: 800;
    margin-left: 20px;
    color: #909399;
  }

  .col-right {
    /*background-color: #DCDEE3;*/
    border-radius: 4px;
    padding: 5px;
    font-size: 15px;
    font-weight: 800;
  }

  .button {
    margin-top: 15px;
    width: 100%;
    text-align: center;
  }

  .charge-success >>> .el-dialog {
    border: 0px;
    border-style: solid;
    border-radius: 2%;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    width: 80%;
    height: 60%;
  }
  .charge-success >>> .el-dialog__body {
    height: 85%;
    padding: 5%;
  }
  .charge-success >>> .el-dialog__header {
    height: 20px;
    text-align: center;
  }
  .charge-success >>> .el-dialog__title {
    position: relative;
    top: -5px;
    font-size: 15px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/chargeSuccess.vue